import http from './http';

const headers = {
  urlPrefix: 'crs-order',
};

// 积分抵扣开关
export const queryCrsPointsSwitch = () => {
  return http({
    url: '/crs/shop/manager/getPointStatus',
  });
};

// 获取邀请单订单订单分页列表
export const queryInviteOrderPageList = (data) => {
  return http({
    method: 'POST',
    url: '/api/invite/pms/inviteOrderPageList',
    data,
    headers,
  });
};

// 查询邀请单会员信息
export const queryInviteMemberInfo = (data) => {
  return http({
    method: 'POST',
    url: '/api/invite/pms/inviteMemberInfo',
    data,
    headers,
  });
};

// 邀请单订单详情
export const queryInviteOrderInfo = (data) => {
  return http({
    method: 'POST',
    url: '/api/invite/pms/inviteOrderInfo',
    data,
    headers,
  });
};

// 邀请单实时计价
export const queryInviteCalculation = (data) => {
  return http({
    method: 'POST',
    url: '/api/invite/pms/inviteCalculation',
    data,
    headers: {
      urlPrefix: 'crs-order',
    },
  });
};

// 关闭邀请单支付
export const queryInviteCloseOrder = (data) => {
  return http({
    method: 'POST',
    url: '/api/invite/pms/inviteCloseOrder',
    data,
    headers,
  });
};

// 提交邀请单订单
export const queryInviteSubmitOrder = (data) => {
  return http({
    method: 'POST',
    url: '/api/invite/pms/inviteSubmitOrder',
    data,
    headers: {
      urlPrefix: 'crs-order',
    },
  });
};

// 获取邀请单订单券列表
export const queryInviteHotelCoupon = (data) => {
  return http({
    method: 'POST',
    url: '/api/invite/pms/inviteHotelCoupon',
    data,
    headers: {
      urlPrefix: 'crs-order',
    },
  });
};

// 获取全日房信息列表
export const queryDayRoomListV3 = (data, header) => {
  return http({
    method: 'POST',
    url: '/api/dj/dayRoomMorningList',
    data,
    headers: {
      urlPrefix: 'asset-web',
      ...header,
    },
  });
};

// 获取钟点房信息列表
export const queryTimeRoomListV3 = (data, header) => {
  return http({
    method: 'POST',
    url: '/api/dj/timeRoomListV3',
    data,
    headers: {
      urlPrefix: 'asset-web',
      ...header,
    },
  });
};

// 获取全日房信息列表
export const getInviteOrderInfo = (params) => {
  return http({
    method: 'GET',
    url: '/api/invite/app/inviteOrderInfo',
    params,
    headers: {
      urlPrefix: 'crs-order',
    },
  });
};

// 钟点房可预订时间段
export const queryInvitePrepare = (data) => {
  return http({
    method: 'POST',
    url: '/api/invite/pms/invitePrepare',
    data,
    headers,
  });
};

// 产品列表
export const queryProductList = (data) => {
  return http({
    method: 'post',
    url: '/ota/product/list',
    data,
  });
};
